import React from "react";

/**
 * Shows out of stock / low stock based on available qty and inventory setting threshold.
 * Renders nothing when quantity is unknown (API did not send stock fields).
 */
const StockStatus = ({
  availableQuantity,
  // lowStockThreshold = 5, // unused — "Only X left" flag is hidden
  soldOut = false,
  className = "",
}) => {
  const hasQty =
    availableQuantity !== undefined &&
    availableQuantity !== null &&
    availableQuantity !== "";

  if (!hasQty && !soldOut) {
    return null;
  }

  const qty = hasQty ? Number(availableQuantity) || 0 : 0;
  // const threshold = Number(lowStockThreshold);
  // const thresholdValue = Number.isFinite(threshold) ? threshold : 5;
  const isOutOfStock = Boolean(soldOut) || (hasQty && qty <= 0);
  // const isLowStock = !isOutOfStock && hasQty && qty <= thresholdValue;

  if (isOutOfStock) {
    return (
      <div className={`bg-red-500 text-white text-[10px] leading-none sm:text-xs sm:leading-normal px-1.5 py-0.5 sm:px-3 sm:py-1 rounded-sm w-fit max-w-full whitespace-nowrap ${className}`}>
        Out of Stock
      </div>
    );
  }

  // "Only X left" low-stock flag — hidden on storefront for now.
  // if (isLowStock) {
  //   return (
  //     <div className={`bg-amber-500 text-white text-[10px] leading-none sm:text-xs sm:leading-normal px-1.5 py-0.5 sm:px-3 sm:py-1 rounded-sm w-fit max-w-full whitespace-nowrap ${className}`}>
  //       Only {qty} left
  //     </div>
  //   );
  // }

  return null;
};

export default StockStatus;
